// TO ITEM
import React, { useEffect, useState, Fragment } from 'react';
import { Row, Col, message, Spin, Space, Button, Typography, Form, Empty } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import FormGroup from 'Molecules/FormGroup';
import { useDispatch, useSelector } from 'react-redux';
import { getToItemList, getTransferOut, patchToItemList } from '../../../../../ducks/actions'
import { editToItem, addToItem, removeToItem } from '../../../../../ducks/services'
import { Popup } from 'Atoms/Popup';
import { LoadingOutlined } from '@ant-design/icons';
import { useForm } from 'react-hook-form';
import Search from './Search'
import ActionButton from 'Molecules/ActionButton';
import { useTranslate } from 'Translate';

const _ = require('lodash');

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const { id, activeTab, data, allowedEdit, allowedDelete, reloadCount } = props;
  const { control, formState: { errors }, handleSubmit, setValue, getValues } = useForm();
  const toItems = useSelector((state) => state.inventory.toItems);
  const meta = useSelector((state) => state.inventory.toItemsOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [load, setLoad] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchVal, setSearchVal] = useState();
  const editable = data?.status === "pending" && allowedEdit;
  const [selectedItem, setSelectedItem] = useState(null);
  const [isSemiProduct, setIsSemiProduct] = useState(false);
  const [isIngredient, setIsIngredient] = useState(true);
  const i18n = useTranslate();
    const { t } = i18n;

  const colName = [
    {
      title: t("General.number_no"),
      dataIndex: 'index',
      key: 'index',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("General.item"),
      dataIndex: 'code',
      key: 'code',
      sorter: true,
      className: 'enable-click',
      render: (text, record) => <span>{text} {record.desc}</span>
    },
    {
      title: t("General.uom"),
      dataIndex: 'uom_code',
      key: 'uom_code',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("General.qty"),
      dataIndex: 'quantity',
      key: 'quantity',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("Inventory.weight"),
      dataIndex: 'weight',
      key: 'weight',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("System.remarks"),
      dataIndex: 'remarks',
      key: 'remarks',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("Inventory.is_ing"),
      dataIndex: 'is_ingredient',
      key: 'is_ingredient',
      sorter: true,
      className: 'enable-click',
      align: 'center',
      render: (text, record) => record?.is_semi_product === "1" ? text === "1" ? t("General.yes") : "-" : t("General.no")
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="transfer_out_item"
          btnAction1={editable ? () => {
            setVisible(true);
            setValue('id', record.id);
            setValue('item', record.product_id ? { label: `${record.code} ${record.desc}`, value: record.product_id } : '');
            setValue('quantity', record.quantity);
            setValue('remarks', record.remarks);
            setSelectedItem(record.product_id);
            setValue('uom', record.uom_id ? { label: record.uom_code, value: record.uom_id } : "");
            setIsSemiProduct(record.is_semi_product === "1");
            setValue('is_ingredient', record.is_ingredient === "1");
            setIsIngredient(record.is_semi_product === "1" ? record.is_ingredient === "1" ? true : false : true);
          } : false}
          onRemove={(data?.status === "pending" && allowedDelete) && onRemove}
          recordId={record.id}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const formFields = [
    {
      name: 'id',
      label: '',
      type: 'input',
      hidden: true,
    },
    {
      name: 'item',
      label: t("General.item"),
      req: true,
      placeholder: t("General.please_select"),
      type: 'select',
      class: 'default-select',
      options: _.map(meta?.products, (e) => ({ ...e, label: `${e.code} ${e.name}`, value: e.id })),
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      onChange: (e) => {
        setSelectedItem(e.value);
        let baseUom = e.product_uoms?.find(x => x.is_base_uom === "1");
        setValue('uom', baseUom ? { label: baseUom?.code, value: baseUom?.id } : '');
        if (e.is_semi_product === "1") {
          setIsSemiProduct(true)
          setIsIngredient(true)
          setValue("is_ingredient", true);
        } else {
          setIsSemiProduct(false)
          setIsIngredient(true)
          setValue("is_ingredient", false);
        }
      }
    },
    {
      name: 'quantity',
      label: t("General.qty"),
      req: true,
      placeholder: t("General.please_select"),
      type: 'input',
      number: true,
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      selectAllOnFocus: true,
    },
    {
      name: 'uom',
      label: t("General.uom"),
      req: true,
      placeholder: t("General.please_select"),
      type: 'select',
      class: 'default-select',
      options: meta?.products?.find(item => item.id === selectedItem)?.product_uoms.map(item => ({label: item.code, value: item.id})),
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      hidden: !isIngredient
    },
    {
      name: 'is_ingredient',
      label: t("Product.is_ingredient"),
      req: false,
      type: 'switch',
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      hidden: !isSemiProduct,
      onChange: (e) => {
        setIsIngredient(e)
      }
    },
    {
      name: 'remarks',
      label: t("System.remarks"),
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 100%'
    },
  ];

  useEffect(() => {
    if (activeTab === "2")
      dispatch(getToItemList(1, limit, '', '', null, setLoad, id));
  }, [activeTab]);

  const addNew = () => {
    setVisible(true);
    setValue('id', '');
    setValue('item', '');
    setValue('quantity', '');
    setValue('remarks', '');
    setSelectedItem(null);
    setIsSemiProduct(false);
    setValue('is_ingredient', false);
    setIsIngredient(true);
    setValue('uom', '');
  }

  const btnList = [
    {
      text: `+ ${t("New.item")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    }
  ];

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getToItemList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading, id));
    } else {
      dispatch(getToItemList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading, id));
    }
  }
  
  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        product_code: search?.product_code
      };
      setSearchVal(searching);
      dispatch(getToItemList(1, limit, '', '', searching, props.setLoading, id));
    } else {
      setSearchVal(null);
      dispatch(getToItemList(1, limit, '', '', null, props.setLoading, id));
    }
  };

  const onFinish = async (val) => {
    setLoad(true);

    const payload = {
      quantity: val?.quantity,
      product_id: val?.item?.value,
      remarks: val?.remarks,
      transfer_out_item_id: val?.id,
      transfer_out_id: id,
      uom_id: val?.uom?.value,
      is_ingredient: isSemiProduct ? val?.is_ingredient ? "1" : "0" : "0",
    }
    await (val?.id ? editToItem : addToItem)(payload).then(res => {
      if(res.data.code === 200) {
        message.success(t(`Success.to_item_${val?.id ? "updated" : "added"}`));
        setVisible(false);
        setPage(1);
        reloadCount();
        setTimeout(() => {
          dispatch(patchToItemList(toItems, res.data.data, meta));
          dispatch(getTransferOut(id, setLoad));
          setLoad(false);
        }
        , 500);

      }else {
        setLoad(false);
        message.error(res.data.message);
      }
    }).catch(e => {
      setLoad(false);
      message.error(e?.message)
    })
  }

  const onRemove = async (recordId) => {
    setLoad(true);

    const payload = {
      transfer_out_item_id: recordId,
      transfer_out_id: id
    }
    await removeToItem(payload).then(res => {
      setLoad(false);
      if (res.data.code === 200) {
        message.success(t("Success.to_item_removed"));
        setVisible(false);
        setPage(1);
        reloadCount();
        setTimeout(() => {
          dispatch(getToItemList(1, limit, '', '', searchVal, props.setLoading, id))
          dispatch(getTransferOut(id, setLoad));
        }, 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      setLoad(false);
      message.error(e?.message)
    })
  }

  const popup = {
    closable: false,
    visibility: visible,
    content: <Spin indicator={antIcon} size="large" spinning={load}>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Space direction='vertical' size={30} className='w-100'>
          <Title level={4} className='m-0'>
            {getValues('id') ? t("General.edit") : t("General.add")} {t("Inventory.to_item")}
          </Title>
          <Row gutter={[10, 10]}>
            {formFields.map((item, idx) => (
              <Fragment key={idx}>
                <FormGroup item={item} control={control} errors={errors} />
              </Fragment>
            ))}
          </Row>
          <Row gutter={10} justify={'center'}>
            <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => {
              setVisible(false);
              setValue('id', '');
              setValue('item', '');
              setValue('quantity', '');
              setValue('remarks', '');
              setSelectedItem(null);
              setValue('uom', '');
              setIsSemiProduct(false);
              setIsIngredient(true);
              setValue('is_ingredient', false);
            }}>{t("General.cancel")}</Button></Col>
            {
              editable &&
              <Col span={12}><Button size='large' type="primary" className='green-btn w-100' htmlType='submit'>{t("General.confirm")}</Button></Col>
            }
          </Row>
        </Space>
      </Form>
    </Spin>,
    width: 536,
    onCancel: () => {
      setVisible(false);
      setValue('id', '');
      setValue('item', '');
      setValue('quantity', '');
      setValue('remarks', '');
      setSelectedItem(null);
      setValue('uom', '');
      setIsSemiProduct(false);
      setIsIngredient(true);
      setValue('is_ingredient', false);
    },
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click") && editable){
          setValue('id', record.id);
          setValue('item', record.product_id ? { label: `${record.code} ${record.desc}`, value: record.product_id } : '');
          setValue('quantity', record.quantity);
          setValue('remarks', record.remarks);
          setSelectedItem(record.product_id);
          setValue('uom', record.uom_id ? { label: record.uom_code, value: record.uom_id } : "");
          setIsSemiProduct(record.is_semi_product === "1");
          setValue('is_ingredient', record.is_ingredient === "1");
          setIsIngredient(record.is_semi_product === "1" ? record.is_ingredient === "1" ? true : false : true);
          setVisible(true);
        }
      },
    };
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={load}>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={''} btnList={editable ? btnList : []} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            onSearch={onSearch}
            Search={Search}
            onRow={onClickRow}
            ListData={toItems?.list?.map((x, idx) => ({ ...x, key: x.id, index: idx + 1}))}
            onChange={onTableChange}
            ListCol={colName}
            pagination={{
              total: toItems?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...popup} />
    </Spin>
  )
}